
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Receipt, BanknoteIcon, PiggyBank } from 'lucide-react';
import { InvestmentTab } from './tabs/InvestmentTab';
import { BorrowingsTab } from './tabs/BorrowingsTab';
import { LoansTab } from './tabs/LoansTab';

export const AccountingTabs = () => {
  return (
    <Tabs defaultValue="investments" className="space-y-4">
      <TabsList className="grid grid-cols-3 w-[400px]">
        <TabsTrigger value="investments" className="flex items-center gap-2">
          <PiggyBank className="h-4 w-4" />
          <span>Investments</span>
        </TabsTrigger>
        <TabsTrigger value="borrowings" className="flex items-center gap-2">
          <BanknoteIcon className="h-4 w-4" />
          <span>Borrowings</span>
        </TabsTrigger>
        <TabsTrigger value="loans" className="flex items-center gap-2">
          <Receipt className="h-4 w-4" />
          <span>Loans</span>
        </TabsTrigger>
      </TabsList>

      <TabsContent value="investments" className="space-y-4">
        <InvestmentTab />
      </TabsContent>
      
      <TabsContent value="borrowings" className="space-y-4">
        <BorrowingsTab />
      </TabsContent>
      
      <TabsContent value="loans" className="space-y-4">
        <LoansTab />
      </TabsContent>
    </Tabs>
  );
};
